import Supercluster from "supercluster";

export const INVENTORY_HEX = "#E53935";
export const SUBMISSION_HEX = "#43A047";

export function pieSlicePath(cx, cy, r, startDeg, endDeg) {
  if (endDeg - startDeg < 0.05) return "";
  const t0 = (startDeg * Math.PI) / 180;
  const t1 = (endDeg * Math.PI) / 180;
  const x0 = cx + r * Math.cos(t0);
  const y0 = cy + r * Math.sin(t0);
  const x1 = cx + r * Math.cos(t1);
  const y1 = cy + r * Math.sin(t1);
  const largeArc = endDeg - startDeg > 180 ? 1 : 0;
  return `M ${cx} ${cy} L ${x0} ${y0} A ${r} ${r} 0 ${largeArc} 1 ${x1} ${y1} Z`;
}

export function buildCoverageClusterSvg(total, inv, sub) {
  const cx = 120;
  const cy = 120;
  const r = 92;
  const parts = [];

  if (total < 1) {
    parts.push(`<circle cx="${cx}" cy="${cy}" r="${r}" fill="#b0bec5" stroke="#fff" stroke-width="4"/>`);
  } else if (sub === 0) {
    parts.push(`<circle cx="${cx}" cy="${cy}" r="${r}" fill="${INVENTORY_HEX}" stroke="#fff" stroke-width="4"/>`);
  } else if (inv === 0) {
    parts.push(`<circle cx="${cx}" cy="${cy}" r="${r}" fill="${SUBMISSION_HEX}" stroke="#fff" stroke-width="4"/>`);
  } else {
    const invSweep = (360 * inv) / total;
    const a0 = -90;
    const a1 = a0 + invSweep;
    const pInv = pieSlicePath(cx, cy, r, a0, a1);
    const pSub = pieSlicePath(cx, cy, r, a1, a0 + 360);
    if (pInv) parts.push(`<path d="${pInv}" fill="${INVENTORY_HEX}" stroke="#fff" stroke-width="3"/>`);
    if (pSub) parts.push(`<path d="${pSub}" fill="${SUBMISSION_HEX}" stroke="#fff" stroke-width="3"/>`);
  }

  const innerR = 54;
  parts.push(`<circle cx="${cx}" cy="${cy}" r="${innerR}" fill="#fafafa" stroke="#eceff1" stroke-width="2"/>`);

  const label = total > 999 ? `${Math.round(total / 1000)}k` : String(total);
  const mainSize = total > 99 ? 34 : 40;
  parts.push(
    `<text x="${cx}" y="${cy + 6}" text-anchor="middle" font-family="Roboto,system-ui,sans-serif" font-size="${mainSize}" font-weight="700" fill="#263238">${label}</text>`,
    `<text x="${cx}" y="${cy + 34}" text-anchor="middle" font-family="Roboto,system-ui,sans-serif" font-size="18" font-weight="600">`,
    `<tspan fill="${INVENTORY_HEX}">I${inv}</tspan><tspan fill="#90a4ae"> · </tspan><tspan fill="${SUBMISSION_HEX}">S${sub}</tspan>`,
    `</text>`
  );

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">${parts.join("")}</svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

export function createCoverageIndex() {
  return new Supercluster({
    radius: 72,
    maxZoom: 19,
    map: props => ({
      invCount: props.layer === "inventory" ? 1 : 0,
      subCount: props.layer === "submission" ? 1 : 0,
    }),
    reduce: (acc, props) => {
      acc.invCount += props.invCount;
      acc.subCount += props.subCount;
    },
  });
}

export function pointToFeature(point, layer) {
  return {
    type: "Feature",
    properties: { layer, point },
    geometry: {
      type: "Point",
      coordinates: [point.lng, point.lat],
    },
  };
}

export function mapBoundsToBbox(bounds) {
  const sw = bounds.getSouthWest();
  const ne = bounds.getNorthEast();
  return [sw.lng(), sw.lat(), ne.lng(), ne.lat()];
}
